import { usePageTitle } from "context/PageTitleContext";
import InfoBox from "components/Profile/InfoBox";
import ProfileTable from "components/Profile/ProfileTable";
import useGetStudent from "../../hooks/useGetStudent";

import styles from "./Profile.module.css";

const Profile = () => {
    usePageTitle("My Profile");
    const { student, error, isLoading } = useGetStudent();

    if (error) {
        return <div>Error loading profile: {error.message}</div>;
    }

    if (isLoading) {
        return <div>Loading...</div>;
    }

    return (
        <div className={styles.InfoBoxContainer}>
            <InfoBox
                title="Gender"
                value={student.biologicalSex}
                type="Gender"
            />
            <InfoBox
                title="Primary Telephone"
                value={student.phoneNumber}
                type="Phone"
            />
            <InfoBox
                title="Emergency Telephone"
                value={student.emergencyPhoneNumber}
                type="Phone"
            />
            <InfoBox
                title="Address"
                value={
                    student.address.line1 +
                    ", " +
                    student.address.city +
                    ", " +
                    student.address.state
                }
                type="Address"
            />
            <InfoBox
                title="Zip Code"
                value={student.address.zipCode}
                type="ZipCode"
            />
            <ProfileTable
                name={student.firstName + " " + student.lastName}
                username={student.emailAddress.split("@")[0]}
                displayName={student.name}
                email={student.emailAddress}
            />
        </div>
    );
};

export default Profile;
